export default "__VITE_ASSET__6PYZzjCD__"